import { SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant } from 'pathfinder/rules-engine/modules/sponsoredWidgetsSponsoredSitewideLogoConsumptionModule';
export function variantToImage(variant, images) {
    switch (variant) {
        case SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant.DESKTOP:
            return images.desktop;
        case SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant.MOBILE:
            return images.mobile;
    }
}
